import Exports from '../components/Exports'

const ExportsPage = () => (
  <Exports />
)

export default ExportsPage
